import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/vi';

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// Extend Vietnamese locale with custom settings
const customViLocale = {
    ...dayjs.Ls.vi,
    weekdays: 'Chủ nhật_Thứ 2_Thứ 3_Thứ 4_Thứ 5_Thứ 6_Thứ 7'.split('_'),
    weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    months: 'Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12'.split('_'),
};

dayjs.locale('vi', customViLocale);

export const formatDate = (date: Date): string => {
    // Array of month names
    const months = [
        "Tháng 1",
        "Tháng 2",
        "Tháng 3",
        "Tháng 4",
        "Tháng 5",
        "Tháng 6",
        "Tháng 7",
        "Tháng 8",
        "Tháng 9",
        "Tháng 10",
        "Tháng 11",
        "Tháng 12",
    ];

    // Extract date components
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    // Format date string
    return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;
};

export const formatDateVi = (date: Date): string => {
    const bangkokDate = dayjs(date).tz('Asia/Bangkok');
    const day = bangkokDate.date().toString().padStart(2, "0");
    const month = (bangkokDate.month() + 1).toString().padStart(2, "0");
    const year = bangkokDate.year();
    
    return `${day}/${month}/${year}`;
};

// export const prepareDate = (s)
export const formatToCustomDateString = (date: string | Date, format: string): string => {
    if (!date) return '';
    const formattedDate = dayjs(date).utc().format(format); 
    return formattedDate;
};

export const formatVietnamTime = (value: string, format: string = "DD/MM HH:mm") => {
    const date = dayjs.utc(value);
    return date.isValid() ? date.tz("Asia/Ho_Chi_Minh").format(format) : "—";
};